module.exports = __webpack_public_path__ + "media/icons/link-youtube@3x-68e1c628.svg";